import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card subdomain-card" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "subdomain-action" }
const _hoisted_4 = ["href"]

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  name: "AppSubdomain",
},
  __name: 'Subdomain',
  props: {
    propMessage: {},
    destination: {},
    imagefile: {},
    name: {}
  },
  setup(__props: any) {



const props = __props;

const imageUrl = computed(() => require(`@/assets/${props.imagefile}`));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("img", {
      src: imageUrl.value,
      alt: "Subdomain image"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", null, [
      _createElementVNode("h2", null, _toDisplayString(__props.name), 1),
      _createElementVNode("p", null, _toDisplayString(__props.propMessage), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: __props.destination,
          target: "_blank",
          rel: "noreferrer"
        }, "Visit site", 8, _hoisted_4)
      ])
    ])
  ]))
}
}

})